<!-- <template>
  <div class="container-fluid">
    <div class="row">
      <div class="head-text">Branch Reports</div>
    </div>
    <div class="row" style="background: #f5f8fa">
      <div class="col-12 col-sm-4 px-0 c-pointer" @click="toggleMember">
        <div class="p-3 header4">Membership</div>
        <div :class="{ baseline: showMember, 'hide-base': !showMember }"></div>
      </div>
      <div class="col-12 col-sm-4 px-0 c-pointer" @click="toggleService">
        <div class="p-3 header4">Church Activities</div>
        <div
          :class="{ baseline: showService, 'hide-base': !showService }"
        ></div>
      </div>
      <div class="col-12 col-sm-4 px-0 c-pointer" @click="toggleFinancial">
        <div class="p-3 header4">Financial</div>
        <div
          :class="{ baseline: showFinancial, 'hide-base': !showFinancial }"
        ></div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 p-0" v-if="showMember">
        <Member />
      </div>
      <div class="col-12 p-0" v-if="showService">
        <Service />
      </div>
      <div class="col-12 p-0" v-if="showFinancial">
        <Financial />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import Member from "./MembershipReport.vue";
import Service from "./ServiceReport.vue";
import Financial from "./financialReport/index.vue";

export default {
  components: {
    Member,
    Service,
    Financial,
  },

  setup() {
    const showMember = ref(true);
    const showService = ref(false);
    const showFinancial = ref(false);

    const toggleMember = () => {
      showMember.value = true;
      showService.value = false;
      showFinancial.value = false;
    };
    const toggleService = () => {
      showMember.value = false;
      showService.value = true;
      showFinancial.value = false;
    };
    const toggleFinancial = () => {
      showMember.value = false;
      showService.value = false;
      showFinancial.value = true;
    };

    return {
      showMember,
      showService,
      showFinancial,
      toggleMember,
      toggleService,
      toggleFinancial,
    };
  },
};
</script>

<style scoped>
.page-header {
  font: normal normal 800 29px Nunito sans;
}

.header4 {
  font-size: 20px;
  font-weight: 700;
  color: #136acd;
}
.baseline {
  transition: all 150ms ease-in-out;
  background-color: #136acd;

  border-radius: 24px;
  bottom: -2.5px;
  height: 4px;
  left: 0px;

  opacity: 1;
}

.hide-base {
  transition: all 150ms ease-in-out;
  background-color: #136acd;
  border-radius: 24px;
  bottom: -2.5px;
  height: 4px;
  left: 0px;
  opacity: 0;
}
</style> -->
<template>
  <div class="container-top container-wide" :class="{ 'd-flex': routerPage }">
    <div class="row" v-if="!routerPage">
      <div class="mt-3 col-md-12">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          {{ branchItem ? branchItem.name : "Organizational" }} Report
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
        <div class="mt-2"><BackRoute /></div>
      </div>
    </div>
    <div class="text-center mt-2" v-if="routerPage">
      <div class="border rounded p-1 cursor-pointer" @click="goBack">
        <el-icon :size="20" class="d-flex"><ArrowLeft /></el-icon>
      </div>
    </div>
    <div class="mt-2" :class="{ 'container-slim': lgAndUp || xlAndUp }">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { watch, ref } from "vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import { useRoute } from "vue-router";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import { useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const routerPage = ref("");
const { lgAndUp, xlAndUp } = deviceBreakpoint();
const goBack = () => {
  router.go(-1);
};

const checkRoute = () => {
  routerPage.value = route.fullPath.includes("/tenant/branchreports/");
};
const branchItem = ref({});
branchItem.value = JSON.parse(localStorage.getItem("branchItem"));

// Watch for route changes
watch(
  () => route.fullPath,
  () => {
    checkRoute();
  },
  { immediate: true }
);
</script>

<style scoped></style>
